import {Injectable} from '@angular/core';
import {formatDate} from '@angular/common';
import {StoreService} from '@app/services/store.service';
import {TfWindowRefService} from '@app/modules/tf-window-ref';

@Injectable({providedIn: 'root'})

export class AnalyticsService {


    constructor(
        private windowRef: TfWindowRefService,
        public storeService: StoreService,
    ) {
    }

    triggerSearchEvent(params): void {
        if (this.windowRef.nativeWindow.digitalData) {
            if (this.windowRef.nativeWindow.digitalData.setPageType
                && typeof this.windowRef.nativeWindow.digitalData.setPageType === 'function') {
                this.windowRef.nativeWindow.digitalData.setPageType('taqman search results:' + this.getProductType() + this.getSearchTypeBySubType());
            }

            const detail = {
                search: {
                    totalResults: '' + params.totalHits,
                    term: params.keyword ? params.keyword : '',
                    type: this.getProductType() + params.type + 's' + this.getSearchTypeBySubType(),
                    filters: {},
                    searchLocation: 'top search',
                    focusarea: 'taqman assays'
                }
            };
            if (params.filters.length > 0) {
                detail.search.filters = params.filters;
            }
            this.windowRef.nativeWindow.digitalData.search = detail.search;
            const event = new CustomEvent('searchResultsUpdated', {
                detail: detail,
                bubbles: true,
                cancelable: true
            });

            this.windowRef.nativeWindow.document.dispatchEvent(event);

        }
    }

    triggerRecommendationEvent(params): void {

        const event = new CustomEvent('recommendationClick', {
            detail: params,
            bubbles: true,
            cancelable: true
        });
        this.windowRef.nativeWindow.document.dispatchEvent(event);

    }

    productHeaderLinkClicked(productID, row): void {

        const event = new CustomEvent('productHeaderLinkClicked', {
            detail: {
                productID: productID,
                row: row,
                isAssayIdClick: true,
                productType: 'taqman'
            },
            bubbles: true,
            cancelable: true
        });
        this.windowRef.nativeWindow.document.dispatchEvent(event);

    }

    compareActionClicked(objParams): void {

        const event = new CustomEvent('compare-action-clicked', {
            detail: {
                type: objParams.productTypeSelect,
                productTypeSelect: objParams.productTypeSelect.toUpperCase()
            },
            bubbles: true,
            cancelable: true
        });
        this.windowRef.nativeWindow.document.dispatchEvent(event);

    }

    selectAllClicked(): void {
        const event = new CustomEvent('selectAll', {
            bubbles: true,
            cancelable: true
        });
        this.windowRef.nativeWindow.document.dispatchEvent(event);

    }

    loadMoreClicked(): void {

        const event = new CustomEvent('scrollLoadMore', {
            bubbles: true,
            cancelable: true
        });
        this.windowRef.nativeWindow.document.dispatchEvent(event);

    }

    triggerAddToCart(params): void {
        const detail: any = {
            products: [{
                catalogNumber: params.catalogNumber,
                designId: params.aid,
                quantity: params.quantity,
                price: params?.price,
                uom: params.uom,
                title: 'TaqMan&amp;&reg;' + this.getProductType() + this.getSearchTypeBySubType(),
                categoryName: this.getProductType() + this.getSearchTypeBySubType(),
                lineName: 'taqman'
            }]
        };

        if (params.loc) {
            detail.products[0].addMethod = params.loc;
        }
        const event = new CustomEvent('cartAdd', {
            detail: detail,
            bubbles: true,
            cancelable: true
        });
        this.windowRef.nativeWindow.document.dispatchEvent(event);

    }

    triggerAddToCartForMirnaArrays(params): void {
        const detail: any = {
            products: [{
                catalogNumber: params.catalogNumber,
                designId: params.aid,
                quantity: params.quantity,
                price: params?.price,
                format: params.format,
                title: 'TaqMan&amp;&reg;' + this.getProductType() + this.getSearchTypeBySubType(),
                categoryName: this.getProductType() + this.getSearchTypeBySubType(),
                lineName: 'taqman'
            }]
        };

        if (params.loc) {
            detail.products[0].addMethod = params.loc;
        }
        const event = new CustomEvent('cartAdd', {
            detail: detail,
            bubbles: true,
            cancelable: true
        });
        this.windowRef.nativeWindow.document.dispatchEvent(event);

    }

    triggerAddToCartMulti(cartItems): void {
        const _products = cartItems.map(params => {

            return {
                catalogNumber: params.catalogNumber,
                designId: params.aid,
                quantity: params.quantity,
                price: params?.price,
                title: 'TaqMan&amp;&reg;' + this.getProductType() + this.getSearchTypeBySubType(),
                categoryName: this.getProductType() + this.getSearchTypeBySubType(),
                lineName: 'taqman',
                uom: params.uom,
            };
        });

        const detail: any = {
            products: _products
        };

        cartItems.map((params, index) => {
            if (params.loc) {
                detail.products[index].addMethod = params.loc;
            }
        });
        const event = new CustomEvent('cartAdd', {
            detail: detail,
            bubbles: true,
            cancelable: true
        });
        this.windowRef.nativeWindow.document.dispatchEvent(event);

    }

    triggerEventForShare(params): void {
        const detail = {
            CustomLink: {
                linkName: params.searchType + ' | ' + params.detail
            }
        };

        const event = new CustomEvent('customLinkClicks', {
            detail: detail,
            bubbles: true,
            cancelable: true
        });
        this.windowRef.nativeWindow.document.dispatchEvent(event);

    }

    triggerEventForDownload(params): void {

        const detail = {
            Downloads: {
                fileName: `${params.searchType} export - ${formatDate(new Date(), 'MM_dd_yyyy', 'en')}.csv`
            }
        };
        const event = new CustomEvent('customDownloads', {
            detail: detail,
            bubbles: true,
            cancelable: true
        });
        this.windowRef.nativeWindow.document.dispatchEvent(event);

    }

    getSearchTypeBySubType(): string | undefined {

        const productSubType = this.storeService.searchResults$.getValue()?.productSubType;
        let subType = '';
        switch (productSubType) {
            case 'ge':
                subType = 'Assays';
                break;
            case 'gx':
                subType = 'Arrays';
                break;
            case 'assay':
                subType = 'Assays';
                break;
            case 'array':
                subType = 'Arrays';
                break;
            case 'gt':
                subType = '';
                break;
            case 'snp':
                subType = ' ';
                break;
            case 'cnv':
                subType = ' ';
                break;
            case 'microrna_advanced' :
                subType = ' Advanced';
                break;
            case 'microrna_classic':
                subType = ' Classic';
                break;
            case 'microrna_primary':
                subType = ' Primary';
                break;
            case 'microrna_array':
                subType = ' Arrays';
                break;
        }
        return subType;
    }

    getProductType(): string | undefined {
        const productType = this.storeService.getProductType();
        switch (productType) {
            case 'ge':
                return 'Gene Expression ';
            case 'snp':
                return 'SNP Genotyping ';
            case 'cnv':
                return 'Copy Number ';
            case 'microrna':
                return 'MicroRNA';
        }

        return ''
    }

    triggerAnalyticsOnLoad(pageName): void {

        if (this.windowRef.nativeWindow.digitalData) {
            if (this.windowRef.nativeWindow.digitalData.setPageType
                && typeof this.windowRef.nativeWindow.digitalData.setPageType === 'function') {
                this.windowRef.nativeWindow.digitalData.setPageType(pageName);
            }

            this.windowRef.nativeWindow.digitalData.page.name = pageName;
            const event = new CustomEvent('digitalDataLoaded', {
                detail: {},
                bubbles: true,
                cancelable: true
            });
            this.windowRef.nativeWindow.document.dispatchEvent(event);
        }

    }
}
